/// <reference path="../bower_components/jquery/dist/jquery.js" />

var baylesMapStyle = [{
    "featureType": "administrative",
    "elementType": "all",
    "stylers": [{
        "visibility": "on"
    }, {
        "lightness": 33
    }]
}, {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [{ "visibility": "off" }]
}, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{
        "color": "#f2e5d4"
    }]
}, {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [{
        "color": "#c5dac6"
    }]
}, {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [{
        "visibility": "on"
    }, {
        "lightness": 20
    }]
}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
        "lightness": 20
    }]
}, {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [{
        "color": "#c5c6c6"
    }]
}, {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [{
        "color": "#e4d7c6"
    }]
}, {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [{
        "color": "#fbfaf7"
    }]
}, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
        "visibility": "on"
    }, {
        "color": "#acbcc9"
    }]
}];

function initializeMapForListing() {
    var ggl = new L.Google('ROADMAP', {
        mapOptions: {
            styles: baylesMapStyle
        }
    });

    var map = L.map('cluster-map', {
        zoom: 16,
        maxZoom: 18,
        minZoom: 4,
        scrollWheelZoom: false,
        zoomControl: false
    });

    var zoomControl = L.control.zoom({
        position: 'bottomright'
    });
    map.addControl(zoomControl);
    var markers = L.markerClusterGroup({
        singleMarkerMode: true,
        iconCreateFunction: function(cluster) {
            var childCount = cluster.getChildCount();
            var c = ' marker-cluster-';
            if (childCount < 10) {
                c += 'small';
            } else if (childCount < 100) {
                c += 'medium';
            } else {
                c += 'large';
            }
            if (childCount > 1) {
                return new L.DivIcon({
                    html: '<div><span><b>' + childCount + '</b></span></div>',
                    className: 'marker-cluster' + c,
                    iconSize: new L.Point(40, 40)
                });
            } else {
                return new L.DivIcon({
                    html: '<div class="marker active"><div class="pin"></div><div class="pulse"></div></div>'
                });
            }
        },
        polygonOptions: {
            fillColor: '#474a4c',
            color: '#474a4c',
            weight: 0,
            opacity: 0,
            fillOpacity: 0.3
        }
    });

    for (var i = 0; i < addressPoints.length; i++) {
        var listing = addressPoints[i];
        var title = listing.ListingId;
        var marker = L.marker(new L.LatLng(listing.Latitude, listing.Longitude));
        markers.addLayer(marker);
    }

    map.addLayer(ggl);

    map.addLayer(markers);

    map.fitBounds(markers.getBounds());
}

function initializeMapForBranches() {
    if ($('#mapContainer').length > 0) {
        var ggl = new L.Google('ROADMAP', {
            mapOptions: {
                styles: baylesMapStyle
            }
        });
        var map = L.map('cluster-map', {
            maxZoom: 18,
            minZoom: 4,
            scrollWheelZoom: false,
            zoomControl: false
        });
        var zoomControl = L.control.zoom({
            position: 'bottomright'
        });
        map.addControl(zoomControl);
        var markers = L.markerClusterGroup({
            singleMarkerMode: true,
            iconCreateFunction: function(cluster) {
                var childCount = cluster.getChildCount();
                var c = ' marker-cluster-';
                if (childCount < 10) {
                    c += 'small';
                } else if (childCount < 100) {
                    c += 'medium';
                } else {
                    c += 'large';
                }
                if (childCount > 1) {
                    return new L.DivIcon({
                        html: '<div><span><b>' + childCount + '</b></span></div>',
                        className: 'marker-cluster' + c,
                        iconSize: new L.Point(40, 40)
                    });
                } else {
                    return new L.DivIcon({
                        html: '<div class="marker"><div class="pin"></div><div class="pulse"></div></div>'
                    });
                }
            },
            polygonOptions: {
                fillColor: '#474a4c',
                color: '#474a4c',
                weight: 0,
                opacity: 0,
                fillOpacity: 0.3
            }
        });

        var geoJsonLayer = L.geoJson(branchesGeoJSON, {
            onEachFeature: function(feature, layer) {
                layer.bindPopup('<div><div><a href="' +
                    feature.properties.Href +
                    '" style="display:block;padding-bottom:56.122449%;" class="embed-responsive"><img alt="' +
                    feature.properties.BranchName +
                    '" class="embed-responsive-item" onerror="this.onerror=null; this.src=\'/public/img/svg/bayleys-office.svg\';" height="490px" width="275px" src="' +
                    feature.properties.Image +
                    '"></a></div></div><div style="width:240px;" class="p-xs"><a href="' +
                    feature.properties.Href +
                    '"><h4 translate="no" class="text-navy m-b-xs m-t-none">' +
                    feature.properties.BranchName +
                    '</h4><h5 class="text-muted m-b-xs m-t-none" translate="no">' +
                    feature.properties.CompanyName +
                    '</h5></a><p class="m-b-xs"><span translate="no">' +
                    feature.properties.Address +
                    '</span></p><p class="m-b-xs">Office: <span translate="no">' +
                    feature.properties.Telephone +
                    '</span></p><p class="m-b-xs"><span translate="no"><a href="mailto:' +
                    feature.properties.Email +
                    '" translate="no">' +
                    feature.properties.Email +
                    '</a></span></p></div><div class="m-t-xs ibox-footer"><a class="btn btn-sm btn-info btn-outline btn-block" href="' +
                    feature.properties.Href +
                    '" title="Read more">Read more</a></div>');
            }
        });
        markers.addLayer(geoJsonLayer);

        map.addLayer(ggl);
        map.addLayer(markers);
        map.on('popupopen', function(centerMarker) {
            var cM = map.project(centerMarker.popup._latlng);
            cM.y -= centerMarker.popup._container.clientHeight / 2;
            map.setView(map.unproject(cM));
            $('.marker.active').removeClass('active');
            centerMarker.popup._source.setIcon(new L.DivIcon({
                html: '<div class="marker active"><div class="pin"></div><div class="pulse"></div></div>'
            }));
        });

        map.fitBounds(markers.getBounds());
    }
}

function initializeMapForSearch() {
    var searchQuery = '';
    if ($('#newSearchForm').length > 0) {
        searchQuery = $('#newSearchForm input:hidden, #newSearchForm input:visible, #newSearchForm input, #newSearchForm select').filter(function() {
            return $(this).val();
        }).serialize();
    }
    var listingLocations;
    $.getJSON('/search-api/map-locations/?' + searchQuery, function(json) {
        listingLocations = json;
        var ggl = new L.Google('ROADMAP', {
            mapOptions: {
                styles: baylesMapStyle
            }
        });
        var map = L.map('cluster-map', {
            maxZoom: 18,
            minZoom: 4,
            scrollWheelZoom: false,
            zoomControl: false
        });

        var zoomControl = L.control.zoom({
            position: 'bottomright'
        });

        var markers = L.markerClusterGroup({
            singleMarkerMode: true,
            iconCreateFunction: function(cluster) {
                var childCount = cluster.getChildCount();
                var c = ' marker-cluster-';
                if (childCount < 10) {
                    c += 'small';
                } else if (childCount < 100) {
                    c += 'medium';
                } else {
                    c += 'large';
                }
                if (childCount > 1) {
                    return new L.DivIcon({
                        html: '<div><span><b>' + childCount + '</b></span></div>',
                        className: 'marker-cluster' + c,
                        iconSize: new L.Point(40, 40)
                    });
                } else {
                    return new L.DivIcon({
                        html: '<div class="marker"><div class="pin"></div><div class="pulse"></div></div>'
                    });
                }
            },
            polygonOptions: {
                fillColor: '#474a4c',
                color: '#474a4c',
                weight: 0,
                opacity: 0,
                fillOpacity: 0.3
            }
        });

        for (var i = 0; i < listingLocations.length; i++) {
            var listing = listingLocations[i];
            var listingId = listing.ListingId;
            var marker = L.marker(new L.LatLng(listing.Latitude, listing.Longitude));
            marker.bindPopup('<a class="btn btn-info btn-sm" href="/' + String(listingId) + '" data-id="' + String(listingId) + '">Read more</a>');
            markers.addLayer(marker);
        }

        map.addLayer(markers);

        map.addLayer(ggl);

        map.addControl(zoomControl);

        map.fitBounds(markers.getBounds());

        map.on('popupopen', function(centerMarker) {
            $('#display-listing').removeClass('in');
            var getListingId = $('.leaflet-popup-content a').data('id');
            $.get('/Search/GetSearchResultListing/' + getListingId)
                .success(function(result) {
                    $('#display-listing').html(result).addClass('in');
                    $('html, body').animate({
                        scrollTop: $('#display-listing').offset().top - 70
                    }, 1000);
                    initializeSearchResults();
                    $(window).lazyLoadXT();
                });
            var cM = map.project(centerMarker.popup._latlng);
            map.setView(map.unproject(cM));
            $('.marker.active').removeClass('active');
            centerMarker.popup._source.setIcon(new L.DivIcon({ html: '<div class="marker active"><div class="pin"></div><div class="pulse"></div></div>' }));
        });
    });
}

function startMapping() {
    if ($('#cluster-map').length > 0) {
        var $mapResults = $('#mapResults'),
            $contactBranches = $('#contactBranches'),
            $listing = $('#listing');

        if ($mapResults.length > 0 ||
            $contactBranches.length > 0 ||
            $listing.length > 0) {

            $('#cluster-map').on('inview', function (event, isInView) {
                if (isInView) {
                    $.getScript('https://www.google.com/jsapi', function () {
                        google.load('maps', '3', {
                            other_params: 'libraries=geometry,places&key=AIzaSyABiOJdCNb0rQsV949-xuT4igGEA-3X1fM',
                            callback: function () {
                                $.cachedScript('/public/js/maps-bundle.min.js').done(function (script) {
                                    if ($mapResults.length > 0) {
                                        $('html, body').animate({
                                            scrollTop: $('#cluster-map').offset().top - 68
                                        }, 1000, initializeMapForSearch());
                                    }
                                    else if ($contactBranches.length > 0) {
                                        initializeMapForBranches();
                                    }
                                    else if ($('#listing').length > 0) {
                                        initializeMapForListing();
                                    }
                                });
                            }
                        });
                    });
                    $('#cluster-map').off('inview');
                }
            });
        }
    }
}